// Location hash is not sent to server, so mark links active on the client
document.addEventListener('turbolinks:load', () => {
  const activeLink = Array.from(document.querySelectorAll('a')).find(a => {
    return a.href === window.location
  })
  if (activeLink) {
    activeLink.classList.add('active')
  }
})
